import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { ServicecallService, ThemeService } from 'src/app/services';

@Component({
  selector: 'app-auth-wrapper',
  templateUrl: './auth-wrapper.component.html',
  styleUrls: ['./auth-wrapper.component.css']
})
export class AuthWrapperComponent implements OnInit, OnDestroy {

  isSelected: any = { isLogin: false, isSignup: false, isForgotPassword: false };
  tenantList: any = [];
  private _getTenantDetailsSubscription: Subscription;

  
  constructor(
    private _router: Router,
    private _service: ServicecallService,
    private _themeService: ThemeService
  ) { }

  ngOnInit(): void {
    this._getTenant();
    const url = this._router.url;
    if (url === '/login') {
      this.isSelected.isLogin = true;
    } else if (url === '/signup') {
      this.isSelected.isSignup = true;
    } else {
      this.isSelected.isForgotPassword = true;
    }
    // Reset theme
    this._themeService?.switchTheme();
  }
  ngOnDestroy(): void {
    this._getTenantDetailsSubscription?.unsubscribe();
  }
  navigateToLaunch() {
    this._router.navigate(['/login']);
  }

  private _getTenant() {
    this._getTenantDetailsSubscription = this._service.getTenantDetails().subscribe({
      next: (res: any) => {
        if (res['status']) {
          if (res['response'] && res['response']['response'].length > 0) {
            this.tenantList = res['response']['response'];
          }
        } else {
          this.tenantList = [];
        }
      }, error: () => {
        this.tenantList = [];
      }
    });
  }

}
